import React from "react";
import { Dashboard, SupervisedUserCircle, Assessment } from  "@material-ui/icons";
import userManagment from "../redux/containers/UserManagementContainer";
import dashboard from "../redux/containers/DashboardContainer";
import transactionReport from "../../src/Components/Backend/reports";

/**
 * frontend
 */
export const getRoutes = [
    {name:"/", url:"/", icon: <Dashboard/>, component: dashboard, showList:false},
    {name:"Sign Up", url:"/signup", icon:<SupervisedUserCircle/>, component:userManagment, showList:true}
];

export const privateRoutes = [
    {name:"Transaction", url:"/transaction", icon: <Dashboard/>, component: dashboard ,showList:true},
    {name:"Technical Service", url:"/technicalService", icon: <Dashboard/>, component: dashboard,showList:true},
    {name:"Account", url:"/account", icon: <Dashboard/>, component: dashboard,showList:true},
    {name:"Products", url:"/products", icon: <Dashboard/>, component: dashboard,showList:true},
    {name:"Redmo", url:"/redmo", icon: <Dashboard/>, component: dashboard,showList:true}
];

export const adminRoutes = [
    {name:"Admin", url:"/admin", icon: <Dashboard/>, component: dashboard,showList:true},
];



/**
 * backend
 */
export const mainMenuItem = [
    {name:"Dashboard", url:"/admin/dashboard", icon: <Dashboard/>, component: dashboard, showList:true},
    {name:"Users", url:"/admin/users", icon:<SupervisedUserCircle/>, component:userManagment, showList:true}
];
export const secondListItem = [
    {name:"Transaction", url:"/admin/report/transaction", icon:<Assessment />, component:transactionReport, showList:true},
];
